import { render, staticRenderFns } from "./CreateAWB.vue?vue&type=template&id=170d349c&"
import script from "./CreateAWB.vue?vue&type=script&lang=js&"
export * from "./CreateAWB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports